// Full Merchfox catalog from POST https://api.mymerchfox.com/storeapi/category (2026-09-09).
// merchfox.js stays the auto-match list. Use this file only for manual FF when the old catalog misses.
const merchfoxManual = [
  {
    "id": "646e997b71",
    "name": "2D-CN Hoodies [646e997b71]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "V",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "7d15a8eb66",
    "name": "2D-CN Hoodies [7d15a8eb66]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "429b596141",
    "name": "2D-CN Kids Hoodie [429b596141]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "light pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "88d96ffc0c",
    "name": "2D-CN Kids Hoodie [88d96ffc0c]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "light pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "51e7dc1ab9",
    "name": "2D-CN Kids T-Shirt [51e7dc1ab9]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "light pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "fadc760cc4",
    "name": "2D-CN Kids T-Shirt [fadc760cc4]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "light pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "747eb716d1",
    "name": "2D-CN Long sleeved [747eb716d1]",
    "color": [
      "White",
      "Black",
      "Dark ChocolateCharcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "MaroonLilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b438b79bd0",
    "name": "2D-CN Long sleeved [b438b79bd0]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1d20c4b4a4",
    "name": "2D-CN Male T-shirt [1d20c4b4a4]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "361f832f5d",
    "name": "2D-CN Male T-shirt [361f832f5d]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "0812f9e8c7",
    "name": "2D-CN Sweatershirt [0812f9e8c7]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1dfbff1e29",
    "name": "2D-CN Sweatershirt [1dfbff1e29]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "425834facc",
    "name": "2D-CN Tank Top [425834facc]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "8859aa5a19",
    "name": "2D-CN Tank Top [8859aa5a19]",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy Blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Water Blue",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army Green",
      "New Ash"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "a702ce3bf1",
    "name": "2D-CN Wash T-shirt [a702ce3bf1]",
    "color": [
      "Black",
      "Blue",
      "Brown",
      "Grey",
      "Pink",
      "Purple"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "bc29d63f29",
    "name": "2D-CN Wash T-shirt [bc29d63f29]",
    "color": [
      "Black",
      "Blue",
      "Brown",
      "Grey",
      "Pink",
      "Purple"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "77c5ada8ea",
    "name": "2D-TQ 30 OZ Cup (C450)",
    "color": [
      "Rose Quartz",
      "Storm Sea",
      "Eucalyptus",
      "Black",
      "Light Green",
      "Light Purple",
      "Red Sleeves",
      "Light Cyan",
      "Bay Leaf",
      "White",
      "Lake Blue",
      "Light Blue",
      "Charcoal",
      "Dune",
      "Barbie Pink",
      "Cream White",
      "Light Pink"
    ],
    "size": [
      "30OZ"
    ]
  },
  {
    "id": "59ac896a66",
    "name": "2D-TQ Kid T-shirt (2DKTX)",
    "color": [
      "White",
      "Black",
      "Dark Chocolate",
      "Charcoal",
      "Purple",
      "Ash",
      "Navy blue",
      "Royal",
      "Light Blue",
      "Safety Pink",
      "Red",
      "Kiwi",
      "Forest Green",
      "Gold",
      "Orange",
      "Navy",
      "Tropical Blue",
      "Maroon",
      "Lilac",
      "Beige",
      "Haze Blue",
      "Violet",
      "Irish Green",
      "Sand",
      "Light Pink",
      "Army green",
      "New Ash"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "af87fbc8cf",
    "name": "2D-TQ Long Sleeved Tee (2DCX)",
    "color": [
      "WHITE",
      "BLACK",
      "DARK CHOCOLATE",
      "CHARCOAL",
      "PURPLE",
      "ASH",
      "NAVY BLUE",
      "ROYAL",
      "LIGHT BLUE",
      "SAFETY PINK",
      "RED",
      "KIWI",
      "FOREST GREEN",
      "GOLD",
      "ORANGE",
      "NAVY",
      "MINT GREEN",
      "TROPICAL BLUE",
      "MAROON",
      "LILAC",
      "BEIGE",
      "HAZE BLUE",
      "VIOLET",
      "IRISH GREEN",
      "SAND",
      "LIGHT PINK",
      "ARMY GREEN",
      "NEW ASH"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "049d0ecb87",
    "name": "2D-TQ Male T-shirt (2DTX)",
    "color": [
      "WHITE",
      "BLACK",
      "DARK CHOCOLATE",
      "CHARCOAL",
      "PURPLE",
      "ASH",
      "NAVY BLUE",
      "ROYAL",
      "LIGHT BLUE",
      "SAFETY PINK",
      "RED",
      "KIWI",
      "FOREST GREEN",
      "GOLD",
      "ORANGE",
      "NAVY",
      "MINT GREEN",
      "TROPICAL BLUE",
      "MAROON",
      "LILAC",
      "BEIGE",
      "HAZE BLUE",
      "VIOLET",
      "IRISH GREEN",
      "SAND",
      "LIGHT PINK",
      "ARMY GREEN",
      "NEW ASH"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "25af0bf9e5",
    "name": "3D-CN AOP Crop-tshirt [25af0bf9e5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "4b8e96a7f6",
    "name": "3D-CN AOP Crop-tshirt [4b8e96a7f6]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "909c6f57ef",
    "name": "3D-CN AOP Men's bateau collar zipper short-sleeved T-shirt that does not reach the collar [909c6f57ef]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e0867ea20d",
    "name": "3D-CN AOP Men's bateau collar zipper short-sleeved T-shirt that does not reach the collar [e0867ea20d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1e946e6fe9",
    "name": "3D-CN AOP racing tank top [1e946e6fe9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "8cca85793e",
    "name": "3D-CN AOP Racing Tank Top [8cca85793e]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a12c720438",
    "name": "3D-CN AOP Racing Tank Top [a12c720438]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d6c4e1a7b2",
    "name": "3D-CN AOP racing tank top [d6c4e1a7b2]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "4b90d945f1",
    "name": "3D-CN AOP Unisex Tank Top [4b90d945f1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "73212f94a1",
    "name": "3D-CN AOP Unisex Tank Top [73212f94a1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "7e1785db5b",
    "name": "3D-CN AOP women's cross swimsuit underwear [7e1785db5b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "cc17328721",
    "name": "3D-CN AOP women's cross swimsuit underwear [cc17328721]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "154db3d7f0",
    "name": "3D-CN AOP Women's slant pocket top shorts [154db3d7f0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "SX",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "4beccf8d0b",
    "name": "3D-CN AOP Women's slant pocket top shorts [4beccf8d0b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "0bdc3ddcf3",
    "name": "3D-CN Baseball Jacket [0bdc3ddcf3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "3bbf041e2d",
    "name": "3D-CN Baseball Jacket [3bbf041e2d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6118f617f7",
    "name": "3D-CN Baseball Jacket [6118f617f7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9cb3e9ca23",
    "name": "3D-CN Baseball Jacket [9cb3e9ca23]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "c0862da8b4",
    "name": "3D-CN Baseball Jacket [c0862da8b4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "f56bfaa81d",
    "name": "3D-CN Baseball Jacket [f56bfaa81d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "454c59b438",
    "name": "3D-CN Baseball Jersey (Border) [454c59b438]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9ace5cd4f3",
    "name": "3D-CN Baseball Jersey (Border) [9ace5cd4f3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "12b7047951",
    "name": "3D-CN Baseball Jersey [12b7047951]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "2815bd352f",
    "name": "3D-CN Baseball Jersey [2815bd352f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "29f3003a37",
    "name": "3D-CN Baseball Jersey [29f3003a37]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "7fabf74344",
    "name": "3D-CN Baseball Jersey [7fabf74344]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a62cbf7348",
    "name": "3D-CN Baseball Jersey [a62cbf7348]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "b895044d5b",
    "name": "3D-CN Baseball Jersey [b895044d5b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "2f89858deb",
    "name": "3D-CN Basketball Jersey [2f89858deb]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "63982164eb",
    "name": "3D-CN Basketball Jersey [63982164eb]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "5392285015",
    "name": "3D-CN Basketball Pants [5392285015]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "fddbe14fb2",
    "name": "3D-CN Basketball Pants [fddbe14fb2]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "5fb1e810c1",
    "name": "3D-CN Beach Pants with Slanted Pockets [5fb1e810c1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "978f880cc8",
    "name": "3D-CN Beach Pants with Slanted Pockets [978f880cc8]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "921828d746",
    "name": "3D-CN Beach Shorts [921828d746]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "a3d14b034a",
    "name": "3D-CN Beach Shorts [a3d14b034a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "587e5757bf",
    "name": "3D-CN Beach shorts with back pockets [587e5757bf]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "6a1fb694d2",
    "name": "3D-CN Beach shorts with back pockets [6a1fb694d2]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "16f1b0bbff",
    "name": "3D-CN Bikini [16f1b0bbff]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "9738c20b74",
    "name": "3D-CN Bikini [9738c20b74]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "ba18d428f1",
    "name": "3D-CN Black elastic four-needle six-thread men's trousers [ba18d428f1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d0fe950e11",
    "name": "3D-CN Black elastic four-needle six-thread men's trousers [d0fe950e11]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "2dde0c5f46",
    "name": "3D-CN Boat collar zipper short sleeves (not up to the collar) [2dde0c5f46]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f7da28e59d",
    "name": "3D-CN Boat collar zipper short sleeves (not up to the collar) [f7da28e59d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "183e1b6493",
    "name": "3D-CN Bomber Jacket [183e1b6493]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9a6f6229d5",
    "name": "3D-CN Bomber Jacket [9a6f6229d5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "49c64e298c",
    "name": "3D-CN Bow-Knot Bikini [49c64e298c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b325459ebc",
    "name": "3D-CN Bow-Knot Bikini [b325459ebc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "7fa099e85c",
    "name": "3D-CN Children's Button Baseball Jersey [7fa099e85c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "6M",
      "12M",
      "2T",
      "3T",
      "4T",
      "6T",
      "8T",
      "10T",
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "ba67e91844",
    "name": "3D-CN Children's Button Baseball Jersey [ba67e91844]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "6M",
      "12M",
      "2T",
      "3T",
      "4T",
      "6T",
      "8T",
      "10T",
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "610a215d44",
    "name": "3D-CN Children's Clothes Cuffless Hem POLO Shirt Short Sleeve [610a215d44]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "89233251c8",
    "name": "3D-CN Children's Clothes Cuffless Hem POLO Shirt Short Sleeve [89233251c8]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "a72e054005",
    "name": "3D-CN Children's Double Collar Short Sleeve Shirt [a72e054005]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "be36970ebb",
    "name": "3D-CN Children's Double Collar Short Sleeve Shirt [be36970ebb]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "492ffec0d9",
    "name": "3D-CN Children's hooded sweatshirt [492ffec0d9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "9d0e89c949",
    "name": "3D-CN Children's hooded sweatshirt [9d0e89c949]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "c7edf84914",
    "name": "3D-CN Children's long-sleeved pajamas [c7edf84914]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "3XS",
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "f1fd4dabf6",
    "name": "3D-CN Children's long-sleeved pajamas [f1fd4dabf6]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "3XS",
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "16294c434f",
    "name": "3D-CN Children's Pajamas Set [16294c434f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2Y",
      "4Y",
      "6Y",
      "8Y",
      "10Y"
    ]
  },
  {
    "id": "742a44fc25",
    "name": "3D-CN Children's Pajamas Set [742a44fc25]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2Y",
      "4Y",
      "6Y",
      "8Y",
      "10Y"
    ]
  },
  {
    "id": "06cd293e35",
    "name": "3D-CN Children's patch pocket zip-up shirt [06cd293e35]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "560c3599ea",
    "name": "3D-CN Children's patch pocket zip-up shirt [560c3599ea]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "33cd6b6948",
    "name": "3D-CN Children's round neck imitation cotton short-sleeved T-shirt [33cd6b6948]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "d5971c6a5a",
    "name": "3D-CN Children's round neck imitation cotton short-sleeved T-shirt [d5971c6a5a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "4",
      "5",
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "32f2914429",
    "name": "3D-CN Children's Shirts [32f2914429]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d57553fcac",
    "name": "3D-CN Children's Shirts [d57553fcac]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "0db09e9483",
    "name": "3D-CN Criss Cross Tank Top [0db09e9483]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "52209e2436",
    "name": "3D-CN Criss Cross Tank Top [52209e2436]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "231948b8e7",
    "name": "3D-CN Cross Open Back Camisole Tank Top [231948b8e7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f9ac64a382",
    "name": "3D-CN Cross Open Back Camisole Tank Top [f9ac64a382]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "0652f196d6",
    "name": "3D-CN Cycling suit [0652f196d6]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "3913b65677",
    "name": "3D-CN Cycling suit [3913b65677]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "a3ac48c2da",
    "name": "3D-CN Female Shirts [a3ac48c2da]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "e74067147e",
    "name": "3D-CN Female Shirts [e74067147e]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "8e0c4e27fc",
    "name": "3D-CN Fleece/Warm Hoodie [8e0c4e27fc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "c87c9e6977",
    "name": "3D-CN Fleece/Warm Hoodie [c87c9e6977]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "1657b03747",
    "name": "3D-CN Fleece/Warm Jacket [1657b03747]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "18f139e74e",
    "name": "3D-CN Fleece/Warm Jacket [18f139e74e]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "a1193cd799",
    "name": "3D-CN Fleece/Warm Stand collar jacket [a1193cd799]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d0e4553a09",
    "name": "3D-CN Fleece/Warm Stand collar jacket [d0e4553a09]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "136ac2b4ab",
    "name": "3D-CN Fleece/Warm Zipper Hoodie [136ac2b4ab]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d8643b6076",
    "name": "3D-CN Fleece/Warm Zipper Hoodie [d8643b6076]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9854756bb7",
    "name": "3D-CN Harem Pants [9854756bb7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "OneSize"
    ]
  },
  {
    "id": "aeebcfc671",
    "name": "3D-CN Harem Pants [aeebcfc671]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "OneSize"
    ]
  },
  {
    "id": "91f7440d71",
    "name": "3D-CN Hawaiian Shirt [91f7440d71]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9e923f1112",
    "name": "3D-CN Hawaiian Shirt [9e923f1112]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "524ca8513b",
    "name": "3D-CN Hellowout Tank Top [524ca8513b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "e071850c34",
    "name": "3D-CN Hellowout Tank Top [e071850c34]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "43e4054b58",
    "name": "3D-CN HIGH waist  leggings [43e4054b58]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "683c854d3a",
    "name": "3D-CN HIGH waist  leggings [683c854d3a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "8e82c090f3",
    "name": "3D-CN Hip skirt [8e82c090f3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL",
      "7XL"
    ]
  },
  {
    "id": "95b5d4ca50",
    "name": "3D-CN Hip skirt [95b5d4ca50]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL",
      "7XL"
    ]
  },
  {
    "id": "a27c7ff701",
    "name": "3D-CN Hoodie Dress [a27c7ff701]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "fa55f67098",
    "name": "3D-CN Hoodie Dress [fa55f67098]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "06a94cc05b",
    "name": "3D-CN Hoodies [06a94cc05b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "2d918978ee",
    "name": "3D-CN Hoodies [2d918978ee]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "3ff20a7b8d",
    "name": "3D-CN Hoodies [3ff20a7b8d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "46a0741cd9",
    "name": "3D-CN Hoodies [46a0741cd9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "7e1b15934f",
    "name": "3D-CN Hoodies [7e1b15934f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "804cad8a56",
    "name": "3D-CN Hoodies [804cad8a56]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "90fe00c0fa",
    "name": "3D-CN Hoodies [90fe00c0fa]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "be5d19f3b1",
    "name": "3D-CN Hoodies [be5d19f3b1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "cb3b61fe29",
    "name": "3D-CN Hoodies [cb3b61fe29]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "e7270d1642",
    "name": "3D-CN Hoodies [e7270d1642]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "091966837d",
    "name": "3D-CN jacket  HOODIE [091966837d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "3d1299e4ab",
    "name": "3D-CN jacket  HOODIE [3d1299e4ab]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "33d5efc504",
    "name": "3D-CN Jacket [33d5efc504]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f2c2c28afd",
    "name": "3D-CN Jacket [f2c2c28afd]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "c482a31670",
    "name": "3D-CN KID Baseball Jersey  (Border)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "6M",
      "12M",
      "2T",
      "3T",
      "4T",
      "6T",
      "8T",
      "10T",
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "7cb7cb4745",
    "name": "3D-CN KID Baseball Jersey (Border)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "6M",
      "12M",
      "2T",
      "3T",
      "4T",
      "6T",
      "8T",
      "10T",
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "5b89401216",
    "name": "3D-CN Kid hoodie [5b89401216]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XXS(1-2years)",
      "XS(3-4years)",
      "S(5-6years)",
      "M(7-8years)",
      "L(9-10years)",
      "XL(11-12years)"
    ]
  },
  {
    "id": "fbd89a77cc",
    "name": "3D-CN Kid hoodie [fbd89a77cc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XXS(1-2years)",
      "XS(3-4years)",
      "S(5-6years)",
      "M(7-8years)",
      "L(9-10years)",
      "XL(11-12years)"
    ]
  },
  {
    "id": "2452ab124a",
    "name": "3D-CN Kid Pajamas Long Sleever [2452ab124a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "ac33eff2d5",
    "name": "3D-CN Kid Pajamas Long Sleever [ac33eff2d5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "47eb71fff6",
    "name": "3D-CN Ladies Crop Sweatshirt [47eb71fff6]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "a4e5145dec",
    "name": "3D-CN Ladies Crop Sweatshirt [a4e5145dec]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "4b70df09cc",
    "name": "3D-CN Leggings [4b70df09cc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "5ac332daa1",
    "name": "3D-CN Leggings [5ac332daa1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "ac8a12ad8e",
    "name": "3D-CN Long Pajamas [ac8a12ad8e]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "fe5deea7b1",
    "name": "3D-CN Long Pajamas [fe5deea7b1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "52ed7d1d27",
    "name": "3D-CN Long Sleeve Hoodie [52ed7d1d27]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d156cb2ce4",
    "name": "3D-CN Long Sleeve Hoodie [d156cb2ce4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "43d2eed970",
    "name": "3D-CN Long Sleeve Pajama Pants with Pockets [43d2eed970]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "a0e55a6dd1",
    "name": "3D-CN Long Sleeve Pajama Pants with Pockets [a0e55a6dd1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "06be361f08",
    "name": "3D-CN Long Sleeve Pajama Pants Without Pockets [06be361f08]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "3d39ec92a5",
    "name": "3D-CN Long Sleeve Pajama Pants Without Pockets [3d39ec92a5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "b30148a1f0",
    "name": "3D-CN Long Sleeve Pajamas With Pockets [b30148a1f0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "d816db488f",
    "name": "3D-CN Long Sleeve Pajamas With Pockets [d816db488f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "3cc2eb9a69",
    "name": "3D-CN Long sleeve pajamas with suit collar (no pockets) [3cc2eb9a69]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "b473351f90",
    "name": "3D-CN Long sleeve pajamas with suit collar (no pockets) [b473351f90]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "38efe95aed",
    "name": "3D-CN Long Sleeve Polo Sweatshirt [38efe95aed]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "6ddabfc4f3",
    "name": "3D-CN Long Sleeve Polo Sweatshirt [6ddabfc4f3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "207dc459e0",
    "name": "3D-CN Long Sleeve Sleepwear Without Pockets [207dc459e0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "95ef6493a4",
    "name": "3D-CN Long Sleeve Sleepwear Without Pockets [95ef6493a4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "0388b1732a",
    "name": "3D-CN Long sleeved T-shirt [0388b1732a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "de34dee1ab",
    "name": "3D-CN Long sleeved T-shirt [de34dee1ab]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "66a6ebb6bd",
    "name": "3D-CN Long-sleeved pajama pants [66a6ebb6bd]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "afd382722d",
    "name": "3D-CN Long-sleeved pajama pants [afd382722d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "2d55f14ea6",
    "name": "3D-CN Long-sleeved pajamas with 2 bottom pockets [2d55f14ea6]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "8804694604",
    "name": "3D-CN Long-sleeved pajamas with 2 bottom pockets [8804694604]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "340524d09d",
    "name": "3D-CN Long-sleeved pajamas with one top pocket [340524d09d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "3d6fd13991",
    "name": "3D-CN Long-sleeved pajamas with one top pocket [3d6fd13991]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "6823f9cd77",
    "name": "3D-CN Mask hoodie [6823f9cd77]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d2eaf8c12b",
    "name": "3D-CN Mask hoodie [d2eaf8c12b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "6d7a7096df",
    "name": "3D-CN Men's Boxer Briefs [6d7a7096df]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b9c30cdd64",
    "name": "3D-CN Men's Boxer Briefs [b9c30cdd64]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6ad5bfd78b",
    "name": "3D-CN Men's double collar short sleeve shirt [6ad5bfd78b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "6f2111828c",
    "name": "3D-CN Men's double collar short sleeve shirt [6f2111828c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "ac6a734f16",
    "name": "3D-CN Men's four-needle six-thread sleeveless round neck vest [ac6a734f16]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b665756843",
    "name": "3D-CN Men's four-needle six-thread sleeveless round neck vest [b665756843]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "2041af4c2c",
    "name": "3D-CN Men's shorts with waistband and eyelets [2041af4c2c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "cea30c334f",
    "name": "3D-CN Men's shorts with waistband and eyelets [cea30c334f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "e448190926",
    "name": "3D-CN One-piece bikini [e448190926]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f88280bd86",
    "name": "3D-CN One-piece bikini [f88280bd86]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "332c87261c",
    "name": "3D-CN One-piece swimsuit [332c87261c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "56d4f85b31",
    "name": "3D-CN One-piece swimsuit [56d4f85b31]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "42edd8af3a",
    "name": "3D-CN pajama [42edd8af3a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "9689f8a589",
    "name": "3D-CN pajama [9689f8a589]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "1b90a67f2d",
    "name": "3D-CN Pajama set [1b90a67f2d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9a34937c82",
    "name": "3D-CN Pajama set [9a34937c82]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "37edd8d6d9",
    "name": "3D-CN Pants [37edd8d6d9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "3f89f9e5b1",
    "name": "3D-CN Pants [3f89f9e5b1]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "469c03c82c",
    "name": "3D-CN Pants [469c03c82c]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "cced99bff2",
    "name": "3D-CN Pants [cced99bff2]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "105d49d3a7",
    "name": "3D-CN Pocket double collar short sleeve shirt [105d49d3a7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "71d3833be7",
    "name": "3D-CN Pocket double collar short sleeve shirt [71d3833be7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "16845d005a",
    "name": "3D-CN Pocket Skirt [16845d005a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "6c9da828e4",
    "name": "3D-CN Pocket Skirt [6c9da828e4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "233d6569e3",
    "name": "3D-CN POLO [233d6569e3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "89d4d97fbe",
    "name": "3D-CN POLO [89d4d97fbe]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1c286915c0",
    "name": "3D-CN Polo T Shirt [1c286915c0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "59a9c38079",
    "name": "3D-CN Polo T Shirt [59a9c38079]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "9d2b761ae3",
    "name": "3D-CN Polo T Shirt [9d2b761ae3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "dff9765f25",
    "name": "3D-CN Polo T Shirt [dff9765f25]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "140ad31536",
    "name": "3D-CN Raglan 3/4 Sleeve T shirt [140ad31536]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "e4a83d4d25",
    "name": "3D-CN Raglan 3/4 Sleeve T shirt [e4a83d4d25]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "b50d5e42d4",
    "name": "3D-CN Raglan Long Sleeve [b50d5e42d4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "eec6cae010",
    "name": "3D-CN Raglan Long Sleeve [eec6cae010]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a45db649fe",
    "name": "3D-CN Raglan long sleeves [a45db649fe]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d0e01d34da",
    "name": "3D-CN Raglan long sleeves [d0e01d34da]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9f94b6c3e0",
    "name": "3D-CN Rugby Jersey [9f94b6c3e0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b197f97825",
    "name": "3D-CN Rugby Jersey [b197f97825]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "86c8e0c9cf",
    "name": "3D-CN short sleeve pajamas [86c8e0c9cf]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "ad46afe234",
    "name": "3D-CN short sleeve pajamas [ad46afe234]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "482ea7009b",
    "name": "3D-CN Short-sleeved hoodie [482ea7009b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "640c2c36cc",
    "name": "3D-CN Short-sleeved hoodie [640c2c36cc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "0fee51c2fc",
    "name": "3D-CN Short-sleeved pajamas (no pockets) [0fee51c2fc]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "7b58e76271",
    "name": "3D-CN Short-sleeved pajamas (no pockets) [7b58e76271]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "08263e1dca",
    "name": "3D-CN Stand collar jacket [08263e1dca]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "df6179abf9",
    "name": "3D-CN Stand collar jacket [df6179abf9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "0e2d9e57db",
    "name": "3D-CN Sweatershirt [0e2d9e57db]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "59fabbb45b",
    "name": "3D-CN Sweatershirt [59fabbb45b]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "8a6d917657",
    "name": "3D-CN Sweatershirt [8a6d917657]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "c9fa30e7c8",
    "name": "3D-CN Sweatershirt [c9fa30e7c8]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d0078757eb",
    "name": "3D-CN Sweatershirt [d0078757eb]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d05548a6d5",
    "name": "3D-CN Sweatershirt [d05548a6d5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f9119995cb",
    "name": "3D-CN Sweatershirt [f9119995cb]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "ff5353c659",
    "name": "3D-CN Sweatershirt [ff5353c659]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "017f8f7561",
    "name": "3D-CN T-shirt [017f8f7561]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "50fceb3588",
    "name": "3D-CN T-Shirt [50fceb3588]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "b1117e8718",
    "name": "3D-CN T-shirt [b1117e8718]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "ba545c5fb3",
    "name": "3D-CN T-Shirt [ba545c5fb3]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "e06c788571",
    "name": "3D-CN T-Shirt [e06c788571]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "f29b7e1c76",
    "name": "3D-CN T-Shirt [f29b7e1c76]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "33f95ae241",
    "name": "3D-CN Tight Fitting T-shirt [33f95ae241]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "cb7820a94a",
    "name": "3D-CN Tight Fitting T-shirt [cb7820a94a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1f245efc4d",
    "name": "3D-CN Ugly sweater [1f245efc4d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e145b01ff0",
    "name": "3D-CN Ugly sweater [e145b01ff0]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "58aa61d6ea",
    "name": "3D-CN Unisex Double Threaded Baseball Jersey [58aa61d6ea]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9320982372",
    "name": "3D-CN Unisex Double Threaded Baseball Jersey [9320982372]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "500e603c7f",
    "name": "3D-CN Unisex pull-on beach shorts [500e603c7f]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "a903192242",
    "name": "3D-CN Unisex pull-on beach shorts [a903192242]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "5f0ccb7205",
    "name": "3D-CN V-neck front center stitching short sleeves [5f0ccb7205]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "a475290279",
    "name": "3D-CN V-neck front center stitching short sleeves [a475290279]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "76935e3944",
    "name": "3D-CN V-neck Slit Short Sleeves [76935e3944]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9616461854",
    "name": "3D-CN V-neck Slit Short Sleeves [9616461854]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "212bdd7fce",
    "name": "3D-CN V-Neck T-Shirt [212bdd7fce]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "563c8540fd",
    "name": "3D-CN V-Neck T-Shirt [563c8540fd]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "cd2f1b3c97",
    "name": "3D-CN Woman's Shirt Without Buttons At The Bottom [cd2f1b3c97]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "d8117e76bd",
    "name": "3D-CN Woman's Shirt Without Buttons At The Bottom [d8117e76bd]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "1c70c84d15",
    "name": "3D-CN Women Pyjamas Set [1c70c84d15]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "b3eb740764",
    "name": "3D-CN Women Pyjamas Set [b3eb740764]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "816e717bc5",
    "name": "3D-CN Women tank-top dress [816e717bc5]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "95c9124519",
    "name": "3D-CN Women tank-top dress [95c9124519]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "7fd24bb5f7",
    "name": "3D-CN Women's cardigan sleeveless POLO tank top [7fd24bb5f7]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "cc1764d55d",
    "name": "3D-CN Women's cardigan sleeveless POLO tank top [cc1764d55d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "19eae3a93a",
    "name": "3D-CN Women's crew neck T-shirt [19eae3a93a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "d7b16a98ab",
    "name": "3D-CN Women's crew neck T-shirt [d7b16a98ab]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "3962e3ded4",
    "name": "3D-CN Women's Four-Needle Six-thread Long Sleeves [3962e3ded4]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "cd10640702",
    "name": "3D-CN Women's Four-Needle Six-thread Long Sleeves [cd10640702]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "44445903e9",
    "name": "3D-CN Women's four-needle six-thread short sleeves [44445903e9]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "83e383c826",
    "name": "3D-CN Women's four-needle six-thread short sleeves [83e383c826]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2XS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "184de3d3be",
    "name": "3D-CN Women's Raglan Cropped T-Shirt [184de3d3be]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "76cb98869e",
    "name": "3D-CN Women's Raglan Cropped T-Shirt [76cb98869e]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "c151a31f3a",
    "name": "3D-CN Yoga shorts [c151a31f3a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "e0cb21b40a",
    "name": "3D-CN Yoga shorts [e0cb21b40a]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "7f2bf5aeab",
    "name": "3D-CN Youth Basketball Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "d841c98c0c",
    "name": "3D-CN Youth Basketnall Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "063760f865",
    "name": "3D-CN Zipper Hoodies [063760f865]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "0850f8b623",
    "name": "3D-CN Zipper Hoodies [0850f8b623]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "198f3f6b50",
    "name": "3D-CN Zipper Hoodies [198f3f6b50]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "1b2aa3f8ef",
    "name": "3D-CN Zipper Hoodies [1b2aa3f8ef]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "2a700ae58d",
    "name": "3D-CN Zipper Hoodies [2a700ae58d]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "4131474902",
    "name": "3D-CN Zipper Hoodies [4131474902]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "742d00aaed",
    "name": "3D-CN Zipper Hoodies [742d00aaed]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "cb955f9156",
    "name": "3D-CN Zipper Hoodies [cb955f9156]",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "7b45e2c873",
    "name": "3D-TQ 34 OZ Bullet cup (C724)",
    "color": [
      "3D Print Tumbler&MUG"
    ],
    "size": [
      "34OZ"
    ]
  },
  {
    "id": "a91e75d4cc",
    "name": "3D-TQ 3D Tumbler (TU1)",
    "color": [
      "3D Print Tumbler&MUG"
    ],
    "size": [
      "20OZ"
    ]
  },
  {
    "id": "65cd691e6c",
    "name": "3D-TQ Area Rug (RUG)",
    "color": [
      "3D Print Rugs"
    ],
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "cbd29e46fb",
    "name": "3D-TQ Baseball Jersey (ERBEJ)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "626b453587",
    "name": "3D-TQ Beach Shorts (STK)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "77ead1f575",
    "name": "3D-TQ Bone seam waist shorts (STK14)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "4cd796f85e",
    "name": "3D-TQ Children's sweatshirt (KWY)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "Toddler 2T",
      "Toddler 3T",
      "Toddler 4T",
      "Toddler 4",
      "Toddler 5",
      "Youth XS",
      "Youth S",
      "Youth M",
      "Youth L",
      "Youth XL"
    ]
  },
  {
    "id": "023d0b7854",
    "name": "3D-TQ Children's T-shirt (KTX)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "Toddler 2T",
      "Toddler 3T",
      "Toddler 4T",
      "Toddler 4",
      "Toddler 5",
      "Youth XS",
      "Youth S",
      "Youth M",
      "Youth L",
      "Youth XL"
    ]
  },
  {
    "id": "b469bda85c",
    "name": "3D-TQ CROCS (F51)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48"
    ]
  },
  {
    "id": "849dc04a2f",
    "name": "3D-TQ CROCS KID (BZ1)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "23-24",
      "25-26",
      "27-28",
      "29-30",
      "31-32",
      "33-34"
    ]
  },
  {
    "id": "d349baf15b",
    "name": "3D-TQ Glitter Tumbler (TU5)",
    "color": [
      "3D Print Tumbler&MUG"
    ],
    "size": [
      "20OZ"
    ]
  },
  {
    "id": "05a29d341e",
    "name": "3D-TQ Hawaii Shirt (ECY)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "bac754f2e8",
    "name": "3D-TQ Hoodies (AF)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "befe1b8a1e",
    "name": "3D-TQ Kid hoodie (KAF)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "Toddler 2T",
      "Toddler 3T",
      "Toddler 4T",
      "Toddler 4",
      "Toddler 5",
      "Youth XS",
      "Youth S",
      "Youth M",
      "Youth L",
      "Youth XL"
    ]
  },
  {
    "id": "fe3334a08b",
    "name": "3D-TQ POLO shirt (TZPO1)",
    "color": [
      "White zipper",
      "Black zipper"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "d128352cbe",
    "name": "3D-TQ Polo T-shirt (THPO)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "675c8b4379",
    "name": "3D-TQ Throwback Baseball Shirt (NLBEJ)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL",
      "7XL"
    ]
  },
  {
    "id": "b78b874a7e",
    "name": "3D-TQ Tumbler (TU2)",
    "color": [
      "3D Print Tumbler&MUG"
    ],
    "size": [
      "30OZ"
    ]
  },
  {
    "id": "5723c1234e",
    "name": "3D-TQ Ugly Sweater (ZWY)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "b75d12407d",
    "name": "3D-TQ Unisex T-shirt (TX)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "c106fea576",
    "name": "3D-TQ Wine Tumbler (TU8)",
    "color": [
      "3D Print Tumbler&MUG"
    ],
    "size": [
      "12OZ"
    ]
  },
  {
    "id": "938e98a268",
    "name": "3D-TQ Zipper Hoodies (ZIP)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
      "6XL"
    ]
  },
  {
    "id": "04c8d94550",
    "name": "3D-VN  Mesh football jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "c96204117b",
    "name": "3D-VN All Over Print Christmas Ugly Sweater",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "82f0f28187",
    "name": "3D-VN All Over Print Men Polo Premium Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "718611b222",
    "name": "3D-VN All Over Print Men Tank Top",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "584cbbe009",
    "name": "3D-VN All Over Print Pet Hawaiian Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "d597273a6c",
    "name": "3D-VN All Over Print Player Football Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9cc4a12bcf",
    "name": "3D-VN All Over Print Player Football Long Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "1da74efb51",
    "name": "3D-VN All Over Print Premium 3D T-Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "cba4c8d581",
    "name": "3D-VN All Over Print String Bikini",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "4c255f6e6a",
    "name": "3D-VN All Over Print Women Legging",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "93226496a2",
    "name": "3D-VN All Over Print Women Polo Premium Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "18a3f65f2d",
    "name": "3D-VN All Over Print Women Tank Top",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "23fd230746",
    "name": "3D-VN All Over Print Zipper Polo Bowling Jersey Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "190e8bb9b2",
    "name": "3D-VN All-Over Print and Embroidered Men’s Polo Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d787445838",
    "name": "3D-VN All-Over Print Basketball V-neck Mesh Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e4800c03e9",
    "name": "3D-VN All-Over Print Chest Embroidered Logo Men's Polo Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "66fc2e95fa",
    "name": "3D-VN All-Over Print Curved Hem T-Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "f5ab8ec429",
    "name": "3D-VN All-Over Print Custom Shape Tie",
    "color": [
      "As Design"
    ],
    "size": [
      "10.6x62.2in",
      "11.8x65in"
    ]
  },
  {
    "id": "e6236065be",
    "name": "3D-VN All-over Print Double-sided Lightweight Fleece Blanket",
    "color": [
      "As Design"
    ],
    "size": [
      "30X40",
      "50X60",
      "60X80"
    ]
  },
  {
    "id": "7f38601fe8",
    "name": "3D-VN All-Over Print Embroidered Logo Men's Polo Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "84688f1410",
    "name": "3D-VN All-Over Print Fleece Casual Trousers",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a6186aa89b",
    "name": "3D-VN All-over Print Kid and Youth Satin Pajama Set",
    "color": [
      "As Design"
    ],
    "size": [
      "4Y",
      "6Y",
      "8Y",
      "10Y",
      "12Y",
      "14Y"
    ]
  },
  {
    "id": "2f4b09b0cb",
    "name": "3D-VN All-over Print Kid and Youth Satin Short-Sleeve Pajama Set",
    "color": [
      "As Design"
    ],
    "size": [
      "18M",
      "2T",
      "3T",
      "4T",
      "5T",
      "YXS",
      "YS",
      "YM",
      "YL",
      "YXL"
    ]
  },
  {
    "id": "26ed8404a8",
    "name": "3D-VN All-Over Print Kids T-Shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "3T",
      "4T",
      "5T",
      "YXS",
      "YS",
      "YM",
      "YL",
      "YXL"
    ]
  },
  {
    "id": "4898efdd68",
    "name": "3D-VN All-Over Print Large Tote Bag",
    "color": [
      "As Design"
    ],
    "size": [
      "19.3x14.2x5.5"
    ]
  },
  {
    "id": "71ab646f14",
    "name": "3D-VN All-over Print Lightweight Fleece Blanket",
    "color": [
      "As Design"
    ],
    "size": [
      "30X40",
      "50X60",
      "60X80"
    ]
  },
  {
    "id": "47b3a18f7e",
    "name": "3D-VN All-Over Print Mesh Football Crop Top Jersey",
    "color": [
      "3D Print Cothing"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6bf77e4ec6",
    "name": "3D-VN All-Over Print Overlap V-Neck Mesh Hockey Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "59aa5ced22",
    "name": "3D-VN All-Over Print Pet Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "520007b6bc",
    "name": "3D-VN All-Over Print Pocket Unisex Hawaiian Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e0ff07595a",
    "name": "3D-VN All-Over Print Pocket Unisex Hawaiian Shirt Set",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "4f6f227b65",
    "name": "3D-VN All-Over Print Polo Collar Soccer Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "af352ad5d1",
    "name": "3D-VN All-Over Print Satin Hair Scarf",
    "color": [
      "As Design"
    ],
    "size": [
      "2.4x35.4",
      "2.4x47.2"
    ]
  },
  {
    "id": "9add122611",
    "name": "3D-VN All-Over Print Satin Short-Sleeve Pajama Set with Long Pants",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "3f605c91f2",
    "name": "3D-VN All-Over Print Seamless Sleeve T-shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "de187a9090",
    "name": "3D-VN All-Over Print Short-Sleeve Hawaiian Shirt Set",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "8dec889d02",
    "name": "3D-VN All-Over Print Sports Bra",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "43d4d5e2df",
    "name": "3D-VN All-Over Print Table Runner",
    "color": [
      "As Design"
    ],
    "size": [
      "13x72in",
      "13x90in",
      "13x108in"
    ]
  },
  {
    "id": "5f81458512",
    "name": "3D-VN All-Over Print V-Neck Hockey Jersey (No Logo)",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b893b796ab",
    "name": "3D-VN All-Over Print V-Neck Mesh Football Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "5e5970a2aa",
    "name": "3D-VN All-Over Print V-Neck Mesh Hockey Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a2c88bc1d8",
    "name": "3D-VN All-over Print Women's Hoodie",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6ea217129c",
    "name": "3D-VN All-Over Print Women's Racerback Tank Top",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "18379b2571",
    "name": "3D-VN All-Over Print Women's T-shirt",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "f971b89fca",
    "name": "3D-VN All-Over Print Youth Hawaiian Shorts",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "09fccaee7b",
    "name": "3D-VN All-Over Print Youth Sport Mesh Shorts",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "e0df7b8c65",
    "name": "3D-VN All-OverPrint Mexico Football Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "64ff6619a3",
    "name": "3D-VN AOP Double-Layer Herringbone Satin Bandana",
    "color": [
      "As Design"
    ],
    "size": [
      "17.7x17.7in",
      "23.6x23.6in",
      "27.6x27.6in",
      "35.4x35.4in",
      "43.3x43.3in"
    ]
  },
  {
    "id": "011d6ed32d",
    "name": "3D-VN AOP Double-Layer Smooth Satin Bandana",
    "color": [
      "As Design"
    ],
    "size": [
      "17.7x17.7in",
      "23.6x23.6in",
      "27.6x27.6in",
      "35.4x35.4in",
      "43.3x43.3in"
    ]
  },
  {
    "id": "477cb6c7bb",
    "name": "3D-VN AOP Hockey Rope",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "8fb28d649e",
    "name": "3D-VN AOP Kid Hoodie",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d64b42ad0c",
    "name": "3D-VN AOP Long-Sleeve Polo Collar Football Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "95d31c728e",
    "name": "3D-VN AOP Men's Boxer Briefs",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "51ac5ae780",
    "name": "3D-VN AOP Men's Polo Shirt with Woven Placket Label",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e028cc1aac",
    "name": "3D-VN AOP Single-Layer Herringbone Satin Bandana",
    "color": [
      "As Design"
    ],
    "size": [
      "17.7x17.7in",
      "23.6x23.6in",
      "27.6x27.6in",
      "35.4x35.4in",
      "43.3x43.3in"
    ]
  },
  {
    "id": "1a7d76b7aa",
    "name": "3D-VN AOP Single-Layer Smooth Satin Bandana",
    "color": [
      "As Design"
    ],
    "size": [
      "17.7x17.7in",
      "23.6x23.6in",
      "27.6x27.6in",
      "35.4x35.4in",
      "43.3x43.3in"
    ]
  },
  {
    "id": "f253bde1ab",
    "name": "3D-VN AOP V-Neck Hockey Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "42ef606861",
    "name": "3D-VN AOP Women's Briefs",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "dc26c7e56e",
    "name": "3D-VN Basketball Mesh Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "cee96f3069",
    "name": "3D-VN Basketball Mesh Shorts",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9700795b3a",
    "name": "3D-VN Basketball Shorts",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "feb7bd455c",
    "name": "3D-VN Brazil Redeemer Home Jersey, Embroidered Logo",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "3933aa407f",
    "name": "3D-VN BUTTON UP SHIRT",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "d35c0f02f8",
    "name": "3D-VN Canvas and Double Sides Printed Flag",
    "color": [
      "3D Printed"
    ],
    "size": [
      "12x18",
      "28x40"
    ]
  },
  {
    "id": "2973599573",
    "name": "3D-VN Casual Bikini Set",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "ef6695313f",
    "name": "3D-VN Classic AOP Baseball (2 BUTTONS)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "08b08dd071",
    "name": "3D-VN Graduation Scarf",
    "color": [
      "3D Printed"
    ],
    "size": [
      "5x36 inch"
    ]
  },
  {
    "id": "b12bba9771",
    "name": "3D-VN Graduation Stole",
    "color": [
      "As Design"
    ],
    "size": [
      "5x78in-Flat",
      "5x78in-Pointed"
    ]
  },
  {
    "id": "d290b48606",
    "name": "3D-VN Hoodie 230 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e79e4c3e72",
    "name": "3D-VN Jersey Men Sport Tank Top",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "df469ea554",
    "name": "3D-VN Jersey Men Sport V-Neck Tank Top",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "58b2446ebb",
    "name": "3D-VN Kid Graduation Stole",
    "color": [
      "As Design"
    ],
    "size": [
      "4x50in-Flat",
      "4x50in-Pointed"
    ]
  },
  {
    "id": "f740b20298",
    "name": "3D-VN Kid Youth Baseball Jersey Border",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "6Y",
      "8Y",
      "S(-12Y-)",
      "M(-14Y-)",
      "L(-16-)",
      "10Y"
    ]
  },
  {
    "id": "64025c5751",
    "name": "3D-VN Kid Youth Baseball No Border Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "2T",
      "3T",
      "4T",
      "6Y",
      "8Y",
      "12Y",
      "14Y",
      "16Y",
      "10Y"
    ]
  },
  {
    "id": "12471865f2",
    "name": "3D-VN Loose Sweatpants",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6639f815df",
    "name": "3D-VN Men Soccer Jersey Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "fb8a20dc9d",
    "name": "3D-VN Mexico Polo AOP Long Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "db1ce0f5ea",
    "name": "3D-VN MF All-over Print Hockey Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "f458308d66",
    "name": "3D-VN MF All-over Print Lace Neck Hockey Jersey",
    "color": [
      "As Design"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "78c45f1ca0",
    "name": "3D-VN MF All-Over Print V-Neck Hockey Jersey (No Logo)",
    "color": [
      "As Design"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "a9a91d7e40",
    "name": "3D-VN Pajamas Long Border Set",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9ce89499b2",
    "name": "3D-VN Pajamas Long Pants No Border",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "eee872cda7",
    "name": "3D-VN Pajamas Long Pants with Border",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b676ef48c2",
    "name": "3D-VN PAJAMAS SHORT BORDER",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "df81a5f0f5",
    "name": "3D-VN PREMIUM BASEBALL JERSEY (BORDERS)",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "8c5411c754",
    "name": "3D-VN Premium Hoodie 270 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "72d30a683b",
    "name": "3D-VN Premium Sweatshirt 270 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "98821e51f3",
    "name": "3D-VN Premium Zip Hoodie 270 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "2a4e747c5f",
    "name": "3D-VN Print V-neck Soccer Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "440ac0d1d9",
    "name": "3D-VN Rectangle Fence Flag",
    "color": [
      "As Design"
    ],
    "size": [
      "48x24in",
      "72x36in",
      "96x48in",
      "108x36in"
    ]
  },
  {
    "id": "09c65a30f8",
    "name": "3D-VN Semicircle Fence Flag",
    "color": [
      "As Design"
    ],
    "size": [
      "18x36in",
      "36x72in"
    ]
  },
  {
    "id": "b8295871b6",
    "name": "3D-VN Sport Women Shorts",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "43053fadb7",
    "name": "3D-VN Sweatpant 270 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "4e51e8b2e0",
    "name": "3D-VN Unisex Sweatshirt 230 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6e2ff405b7",
    "name": "3D-VN US Hawaiian Kid",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "5f2c2bb79b",
    "name": "3D-VN US HAWAIIAN SHIRT",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "acb10396a4",
    "name": "3D-VN US HAWAIIAN SHORTS",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "221edbd47b",
    "name": "3D-VN US Mesh Shorts",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "c9ab815348",
    "name": "3D-VN US Soccer Shorts",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9d87da4669",
    "name": "3D-VN USA Polyester and Double Printed Flag",
    "color": [
      "3D Printed"
    ],
    "size": [
      "Horizontal/12*18",
      "Horizontal/28*40",
      "Horizontal/36*60",
      "Vertical/12*18",
      "Vertical/28*40",
      "Vertical/36*60"
    ]
  },
  {
    "id": "18ae13be10",
    "name": "3D-VN Women Crop Top Jersey",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "cfd45afb1e",
    "name": "3D-VN WOMEN PAJAMAS SHORT SET No Border",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "457bacb929",
    "name": "3D-VN Women Sleeveless Cropped Top",
    "color": [
      "3D Printed"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "5606493810",
    "name": "3D-VN Women's Sleeveless Performance Polo Shirt",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "3fe70c0785",
    "name": "3D-VN Zip Hoodie 230 GSM",
    "color": [
      "3D Printed"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "966ee3fbb3",
    "name": "Accent Mug FR",
    "color": [
      "Black",
      "Blue",
      "Navy",
      "Red",
      "Dark Green",
      "Light Green",
      "Pink",
      "Yellow"
    ],
    "size": [
      "11oz"
    ]
  },
  {
    "id": "5539a67a13",
    "name": "Accent Mug US 2",
    "color": [
      "Light Blue",
      "Light Pink",
      "Red",
      "Black"
    ],
    "size": [
      "11oz"
    ]
  },
  {
    "id": "6785a8461b",
    "name": "Acrylic Badge Reel US",
    "color": [
      "Default"
    ],
    "size": [
      "2''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "47aec10dd6",
    "name": "Acrylic Car Visor Clip 1 Layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''",
      "5.5''"
    ]
  },
  {
    "id": "6c2ca887e9",
    "name": "Acrylic Custom Shape Magnets 1 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "f503757411",
    "name": "Acrylic Custom shape Standing 1 layer (3mm) US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "51e666a1c3",
    "name": "Acrylic custom shape Standing 2 layer (3mm) US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "28dc4b3221",
    "name": "Acrylic Custom Shaped Ornament 2 side US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4''",
      "4.5''",
      "5''",
      "5.5''",
      "6''",
      "7''"
    ]
  },
  {
    "id": "db6f4d6511",
    "name": "Acrylic Custom Shaped Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4''",
      "4.5''",
      "5''",
      "5.5''",
      "6''",
      "7''"
    ]
  },
  {
    "id": "efed6a9e08",
    "name": "Acrylic Keychain 2 side US",
    "color": [
      "Default",
      "Transparent"
    ],
    "size": [
      "2''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "22e5876069",
    "name": "Acrylic Keychain US",
    "color": [
      "Default"
    ],
    "size": [
      "2''",
      "3''",
      "4''",
      "3.5''x4.5''",
      "4''x5''"
    ]
  },
  {
    "id": "f5b1cff093",
    "name": "Acrylic Ornament Car 2 side US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''"
    ]
  },
  {
    "id": "a6376826cf",
    "name": "Acrylic Ornament Car US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''"
    ]
  },
  {
    "id": "e87a85d76e",
    "name": "Acrylic Personalized Photo Bookmark US",
    "color": [
      "Gray",
      "Pink",
      "Dark Green",
      "Sky Blue",
      "Deep Green"
    ],
    "size": [
      "2''x8''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "53eb930cfc",
    "name": "Adult Tank Top G2200 2D US",
    "color": [
      "BLACK",
      "WHITE",
      "SPORT GREY",
      "NAVY",
      "CHARCOAL",
      "RED",
      "ROYAL BLUE"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "4ed3053239",
    "name": "Baby Bodysuit Babybugz FR",
    "color": [
      "White",
      "Black",
      "Pink",
      "Blue"
    ],
    "size": [
      "0_3M",
      "3_6M",
      "6_12M",
      "12_18M"
    ]
  },
  {
    "id": "416ac65cd6",
    "name": "Baby T-shirt Babybugz FR",
    "color": [
      "White",
      "Black",
      "Blue",
      "Pink"
    ],
    "size": [
      "0_3M",
      "3_6M",
      "6_12M",
      "12_18M"
    ]
  },
  {
    "id": "7a2b744651",
    "name": "Bella Canvas 3001 T-shirt 2D US",
    "color": [
      "Black",
      "White",
      "Dark Grey Heather",
      "Natural",
      "AQUA",
      "ARMY",
      "ASHGREY",
      "ASPHALT",
      "ATLANTIC",
      "AUTUMN",
      "BABYBLUE",
      "BERRY",
      "BLUESTORM",
      "BROWN",
      "BURNTORANGE",
      "CANVASRED",
      "CARDINALRED_BC3001",
      "CAROLINABLUE_G5K",
      "CHARITYPINK",
      "CHESTNUT",
      "CITRON",
      "CLAY",
      "COCOA",
      "COLUMBIABLUE",
      "COOLBLUE",
      "CORAL",
      "DARKLAVENDER",
      "DARKOLIVE",
      "DEEPTEAL",
      "DUST",
      "DUSTYBLUE",
      "ELECTRICBLUE",
      "EVERGREEN",
      "FORESTGREEN",
      "FUCHSIA",
      "GOLD",
      "HUNTERGREEN",
      "KELLY",
      "LAVENDERBLUE",
      "LAVENDERDUST",
      "LEAF",
      "LIGHT BLUE",
      "LIGHTVIOLET",
      "LILAC",
      "MAIZE YELLOW",
      "MARINE",
      "MAROON",
      "MAUVE",
      "MILITARY GREEN",
      "MINT",
      "MUSTARD",
      "NAVY",
      "OCEANBLUE",
      "OLIVE",
      "ORANGE",
      "ORCHID",
      "OXBLOODBLACK",
      "PEACH",
      "PEBBLE BROWN",
      "PINE",
      "PINK GRAVEL",
      "PINK",
      "POPPY",
      "PURPLE STORM",
      "RED",
      "ROYAL PURPLE",
      "RUST",
      "SAGE",
      "SAND DUNE",
      "SILVER",
      "SLATE",
      "SOFT CREAM",
      "SOFT PINK",
      "SOLIDATHLETIC GREY",
      "SPRING GREEN",
      "STEEL BLUE",
      "STORM",
      "STROBE",
      "SUNSET",
      "SYNTHETIC GREEN",
      "TAN",
      "TEAL",
      "TEAM NAVY",
      "TEAM PURPLE",
      "TERRACOTTA",
      "THYME",
      "TOAST",
      "TRUEROYAL",
      "TURQUOISE",
      "VINTAGE BLACK",
      "VINTAGE BROWN",
      "VINTAGE DENIM",
      "VINTAGE NAVY",
      "VINTAGE RED",
      "VINTAGE WHITE",
      "YELLOW"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "9923ee080d",
    "name": "Bella Canvas Unisex T-Shirt 3001 US3",
    "color": [
      "Black",
      "White",
      "Natural",
      "Dark Grey",
      "Pink"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "4d183e37e1",
    "name": "Blockout Matte Banner",
    "color": [
      "White"
    ],
    "size": [
      "48''x12''",
      "72''x24''",
      "80''x18''",
      "120''x20''"
    ]
  },
  {
    "id": "5482d61d7c",
    "name": "Canvas FR",
    "color": [
      "Default"
    ],
    "size": [
      "30x20cm",
      "20x30cm",
      "60x40cm",
      "40x60cm",
      "60x90cm",
      "90x60cm"
    ]
  },
  {
    "id": "1cf560c50f",
    "name": "Ceramic Flower Vase Milk-Jug Shape",
    "color": [
      "White"
    ],
    "size": [
      "5.12''x3.15''"
    ]
  },
  {
    "id": "65e62b02e6",
    "name": "Ceramic Mug FR",
    "color": [
      "White"
    ],
    "size": [
      "11oz"
    ]
  },
  {
    "id": "251843b912",
    "name": "Ceramic Mug US 2",
    "color": [
      "Black",
      "White"
    ],
    "size": [
      "11oz",
      "15oz"
    ]
  },
  {
    "id": "4b8eba200c",
    "name": "Ceramic Ornament US 2",
    "color": [
      "Default"
    ],
    "size": [
      "Circle",
      "Heart",
      "Star",
      "Oval",
      "Pack 2 (Only circle shape)",
      "Pack 2 (Only heart shape)",
      "Pack 2 (Only star shape)",
      "Pack 2 (Only oval shape)",
      "Pack 3 (Only circle shape)",
      "Pack 3 (Only heart shape)",
      "Pack 3 (Only star shape)",
      "Pack 3 (Only oval shape)",
      "Pack 5 (Only circle shape)",
      "Pack 5 (Only heart shape)",
      "Pack 5 (Only star shape)",
      "Pack 5 (Only oval shape)"
    ]
  },
  {
    "id": "e930c5dc15",
    "name": "Circle Acrylic Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "4bc045988b",
    "name": "Circle Ceramic Ornament 2 side US",
    "color": [
      "Default"
    ],
    "size": [
      "3''"
    ]
  },
  {
    "id": "5d760005e2",
    "name": "Circle Ceramic Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3''"
    ]
  },
  {
    "id": "6b8eaa36de",
    "name": "Circle Wood Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "cf1b40538f",
    "name": "Clipboard Double-sided",
    "color": [
      "As Design"
    ],
    "size": [
      "9''x12.5''"
    ]
  },
  {
    "id": "9db60a4296",
    "name": "Clipboard Single-sided",
    "color": [
      "As Design"
    ],
    "size": [
      "9''x12.5''"
    ]
  },
  {
    "id": "58dda42030",
    "name": "Comfort 1717 T-Shirt 2D US",
    "color": [
      "Black",
      "White",
      "Pepper",
      "Ivory",
      "Espresso",
      "Blue Spruce",
      "Crimson",
      "Bay",
      "Moss",
      "Blue Jean",
      "Seafoam",
      "Grey",
      "Blossom",
      "Graphite",
      "Violet",
      "BANANA",
      "BERRY",
      "BOYSENBERRY",
      "BRICK",
      "BRIGHT ORANGE",
      "BRIGHT SALMON",
      "BURNT ORANGE",
      "BUTTER",
      "CHALKYMINT",
      "CHAMBRAY",
      "CHILI",
      "CHINA BLUE",
      "CITRUS",
      "CRUNCH BERRY",
      "DENIM",
      "EMERALD",
      "FLO BLUE",
      "GRANITE",
      "GRAPE",
      "GRASS",
      "HEMP",
      "HYDRANGEA",
      "ICEBLUE",
      "ISLAND REEF",
      "KHAKI",
      "LAGOON",
      "LIGHT GREEN",
      "MELON",
      "MIDNIGHT",
      "MUSTARD",
      "MYSTICBLUE",
      "NAVY",
      "NEON BLUE",
      "NEON CANTALOUPE",
      "NEON LEMON",
      "NEON PINK",
      "NEON REDORANGE",
      "NEON VIOLET",
      "ORCHID",
      "PAPRIKA",
      "PEACHY",
      "PERIWINKLE",
      "RED",
      "ROYAL CARIBE",
      "SAGE",
      "SAND STONE",
      "SAPPHIRE",
      "TERRACOTTA",
      "TOPAZ BLUE",
      "TRUE NAVY",
      "VINEYARD",
      "WASHED DENIM",
      "WATERMELON",
      "WINE",
      "YAM"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "6f4ba9ed72",
    "name": "Comfort Colors Unisex T-Shirt 1717 US3",
    "color": [
      "Black",
      "White",
      "Ivory",
      "Yam",
      "Light Green",
      "Blossom",
      "Orchid",
      "Pepper",
      "Moss",
      "Blue Jean",
      "Navy",
      "Graphite",
      "Chambray",
      "Espresso"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL"
    ]
  },
  {
    "id": "44987299d6",
    "name": "Cotton Tote Bag FR",
    "color": [
      "White",
      "Natural"
    ],
    "size": [
      "38x42cm"
    ]
  },
  {
    "id": "5a4aeb16bf",
    "name": "Custom Shape Acrylic Sign 1 layer 3mm US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "299fea17c4",
    "name": "Custom Shape Wooden Sign 1 layer - 5mm US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "9faed7303e",
    "name": "Custom Shape Wooden Sign 1 layer 3mm US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "ff2e91e0b4",
    "name": "Custom Shape Wooden Sign 2 layer - 5mm US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "f40691a70c",
    "name": "Custom Shape Wooden Sign 2 layer 3mm US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "01a308519d",
    "name": "Custom Stickers Sheets",
    "color": [
      "Default"
    ],
    "size": [
      "8''x10''",
      "8.5''x11''"
    ]
  },
  {
    "id": "80b1c92932",
    "name": "Die-cut Stickers US 2",
    "color": [
      "Default"
    ],
    "size": [
      "2''x2''",
      "3''x3''",
      "4''x4''",
      "5''x5''",
      "6''x6''"
    ]
  },
  {
    "id": "296132ff0f",
    "name": "Gildan Unisex Crewneck Sweatshirt G18000 US3",
    "color": [
      "Black",
      "White",
      "Military Green",
      "Forest Green",
      "Dark Heather",
      "Sand",
      "Red"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "e362c12b6a",
    "name": "Gildan Unisex Hooded Sweatshirt G18500 US3",
    "color": [
      "Black",
      "White",
      "Sport Grey",
      "Dark Heather",
      "Sand",
      "Navy"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "3b58738746",
    "name": "Gildan Unisex T-Shirt G5000 US3",
    "color": [
      "Black",
      "White",
      "Navy",
      "Sand",
      "Maroon",
      "Light Blue",
      "Tennessee Orange",
      "Charcoal",
      "Orange",
      "Heliconia",
      "Royal",
      "Military Green",
      "Dark Chocolate",
      "Light Pink",
      "Natural",
      "Forest Green",
      "Purple",
      "Ash Grey",
      "Sport Grey",
      "Daisy",
      "Red",
      "Dark Heather"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "2aba6de9ba",
    "name": "Gildan Youth T-Shirt G5000B US3",
    "color": [
      "Black",
      "White",
      "Light Blue",
      "Light Pink",
      "Natural",
      "Sand",
      "Dark Heather",
      "SportGrey"
    ],
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": "58f46d6751",
    "name": "Glass Ornament US 2",
    "color": [
      "Default"
    ],
    "size": [
      "Circle Pack 1",
      "Heart Pack 1"
    ]
  },
  {
    "id": "f66d622c97",
    "name": "Handheld Flag 8''x5.5'' US",
    "color": [
      "White"
    ],
    "size": [
      "Pack 1",
      "Pack 2",
      "Pack 5",
      "Pack 10"
    ]
  },
  {
    "id": "4540014811",
    "name": "Heart Acrylic Plaque 2 side FR",
    "color": [
      "Default"
    ],
    "size": [
      "12x12cm"
    ]
  },
  {
    "id": "b85f5a49a0",
    "name": "Heart Acrylic Plaque FR",
    "color": [
      "Default"
    ],
    "size": [
      "12x12cm"
    ]
  },
  {
    "id": "773694995b",
    "name": "Heart Ceramic Ornament 2 side US",
    "color": [
      "Default"
    ],
    "size": [
      "3''"
    ]
  },
  {
    "id": "99ca58b63b",
    "name": "Heart Ceramic Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3''"
    ]
  },
  {
    "id": "659d64fa2f51e",
    "name": "Hoodie 2D US",
    "color": [
      "BLACK",
      "WHITE",
      "NAVY",
      "SPORT GREY",
      "SAND",
      "FOREST GREEN",
      "LIGHT PINK",
      "ANTIQUE CHERRY RED",
      "ANTIQUE SAPPHIRE",
      "ASHGREY",
      "AZALEA",
      "CARDINALRED",
      "CAROLINABLUE",
      "CHARCOAL",
      "CHERRY RED",
      "DARK CHOCOLATE",
      "DARK HEATHER",
      "GOLD",
      "GRAPHITE HEATHER",
      "HEATHER DARK GREEN",
      "HEATHER DARK MAROON",
      "HEATHER DARK NAVY",
      "HEATHER DEEP ROYAL",
      "HEATHER SCARLET RED",
      "HELICONIA",
      "INDIGO BLUE",
      "IRISH GREEN",
      "LIGHT BLUE",
      "MAROON",
      "MILITARY GREEN",
      "MINTGREEN",
      "OLD GOLD",
      "ORANGE",
      "ORCHID",
      "PURPLE",
      "RED",
      "ROYAL BLUE",
      "SAFETY GREEN",
      "SORANGE",
      "SAFETY PINK",
      "SAPPHIRE",
      "VIOLET"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "c215d2792a",
    "name": "Kids T-Shirt Fruit Of The Loom 610330 FR",
    "color": [
      "White"
    ],
    "size": [
      "2_3Y",
      "3_4Y",
      "5_6Y",
      "7_8Y",
      "9_11Y"
    ]
  },
  {
    "id": "e9fb4f828e",
    "name": "Kiss-cut Stickers US 2",
    "color": [
      "Default"
    ],
    "size": [
      "2''x2''",
      "3''x3''",
      "4''x4''",
      "5''x5''",
      "6''x6''"
    ]
  },
  {
    "id": "41598f8a0e",
    "name": "Matte Framed Canvas 1.25'' US",
    "color": [
      "Black",
      "White",
      "Natural Wood",
      "Walnut",
      "Gold",
      "Silver"
    ],
    "size": [
      "12''x8''",
      "8''x12''",
      "11''x14''",
      "14''x11''",
      "12''x18''",
      "18''x12''",
      "16''x20''",
      "20''x16''",
      "16''x24''",
      "24''x16''",
      "20''x30''",
      "30''x20''",
      "24''x36''",
      "36''x24''"
    ]
  },
  {
    "id": "c9be224591",
    "name": "Matte Stretched Canvas 0.75'' US",
    "color": [
      "Pine Wood"
    ],
    "size": [
      "12''x8''",
      "8''x12''",
      "11''x14''",
      "14''x11''",
      "12''x18''",
      "18''x12''",
      "16''x20''",
      "20''x16''",
      "16''x24''",
      "24''x16''",
      "20''x30''",
      "30''x20''",
      "24''x36''",
      "36''x24''"
    ]
  },
  {
    "id": "beca273fd8",
    "name": "Matte Stretched Canvas 1.25'' US",
    "color": [
      "Pine Wood"
    ],
    "size": [
      "12''x8''",
      "8''x12''",
      "11''x14''",
      "14''x11''",
      "12''x18''",
      "18''x12''",
      "16''x20''",
      "20''x16''",
      "16''x24''",
      "24''x16''",
      "20''x30''",
      "30''x20''",
      "24''x36''",
      "36''x24''"
    ]
  },
  {
    "id": "86232a4399",
    "name": "Matte Wrapping Papers",
    "color": [
      "White"
    ],
    "size": [
      "30''x36''",
      "30''x72''",
      "30''x180''"
    ]
  },
  {
    "id": "58170055fe",
    "name": "Medallion Acrylic Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "4.25''x3''",
      "5.25''x3.7''",
      "6.25''x4.4''"
    ]
  },
  {
    "id": "5560fa5d58",
    "name": "Medallion Wood Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "4.25''x3''",
      "5.25''x3.7''",
      "6.25''x4.4''"
    ]
  },
  {
    "id": "f549bd1322",
    "name": "Metal Coin 2D",
    "color": [
      "Silver",
      "Gold",
      "Rose Gold"
    ],
    "size": [
      "Park 1",
      "Park 2",
      "Park 3",
      "Park 5"
    ]
  },
  {
    "id": "073ee93400",
    "name": "Metal Coin 3D",
    "color": [
      "Silver",
      "Gold",
      "Rose Gold"
    ],
    "size": [
      "Park 1",
      "Park 2",
      "Park 3",
      "Park 5"
    ]
  },
  {
    "id": "7540a9c221",
    "name": "Metal Sign 1mm FR",
    "color": [
      "Default"
    ],
    "size": [
      "20x30cm",
      "30x20cm"
    ]
  },
  {
    "id": "ef5007f96d",
    "name": "Mineral Wash Colortone 1300",
    "color": [
      "Black",
      "Gray",
      "Navy",
      "PURPLE",
      "SILVER"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "329b72d17d",
    "name": "Personalized Suncatcher Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''",
      "12''"
    ]
  },
  {
    "id": "1c0c1a02e2",
    "name": "Photo Building Block US",
    "color": [
      "White"
    ],
    "size": [
      "4.05''x5.71''-Rectangle Single-sided 60 PCS",
      "4.05''x5.71''-Rectangle Double-sided 60 PCS",
      "5.3''x7.2''-Rectangle Single-sided 95 PCS",
      "5.3''x7.2''-Rectangle Double-sided 95 PCS",
      "5.94''x4.17''-Rectangle Single-sided 60 PCS",
      "5.94''x4.17''-Rectangle Double-sided 60 PCS",
      "7.2''x5.3''-Rectangle Single-sided 84 PCS",
      "7.2''x5.3''-Rectangle Double-sided 84 PCS",
      "5.67''x5.67''-Square Single-sided 75 PCS",
      "5.67''x5.67''-Square Double-sided 75 PCS",
      "6.89'''x6.89''-Square Single-sided 108 PCS",
      "6.89''x6.89''-Square Double-sided 108 PCS",
      "6.9''x6.2''-Heart Single-sided 69 PCS",
      "6.9''x6.2''-Heart Double-sided 69 PCS"
    ]
  },
  {
    "id": "a47bfcc1ca",
    "name": "Pillow Cover FR",
    "color": [
      "Default"
    ],
    "size": [
      "Case 40x40cm"
    ]
  },
  {
    "id": "cebb0b6522",
    "name": "Premium Luster Photo Paper Poster US 2",
    "color": [
      "Default"
    ],
    "size": [
      "8''x10''",
      "10''x8''",
      "8''x12''",
      "12''x8''",
      "8''x20''",
      "20''x8''",
      "11''x14''",
      "14''x11''",
      "11''x17''",
      "17''x11''",
      "12''x18''",
      "18''x12''",
      "17''x17''",
      "16''x20''",
      "20''x16''",
      "16''x24''",
      "24''x16''",
      "18''x24''",
      "24''x18''",
      "24''x24''",
      "20''x30''",
      "30''x20''",
      "24''x36''",
      "36''x24''",
      "27''x40''",
      "40''x27''",
      "30''x30''"
    ]
  },
  {
    "id": "2dcbbfbe8e",
    "name": "Rear-clip Clipboard Double-sided",
    "color": [
      "As Design"
    ],
    "size": [
      "9''x12.5''"
    ]
  },
  {
    "id": "65905a458f",
    "name": "Rear-clip Clipboard Single-sided",
    "color": [
      "As Design"
    ],
    "size": [
      "9''x12.5''"
    ]
  },
  {
    "id": "04d1927449",
    "name": "Rectangle Acrylic Night Light US 2",
    "color": [
      "Default"
    ],
    "size": [
      "5.9'' Blank Wooden Base",
      "5.9'' Printed Wooden Base",
      "7.87'' Blank Wooden Base",
      "7.87'' Printed Wooden Base"
    ]
  },
  {
    "id": "dc6a2c71b7",
    "name": "Round Ceramic Ornament 2 side FR",
    "color": [
      "Default"
    ],
    "size": [
      "73x73mm"
    ]
  },
  {
    "id": "509bd68a5a",
    "name": "Round Ceramic Ornament FR",
    "color": [
      "Default"
    ],
    "size": [
      "73x73mm"
    ]
  },
  {
    "id": "97353fa711",
    "name": "Round Glass Ornament 2 side FR",
    "color": [
      "Default"
    ],
    "size": [
      "76x76mm"
    ]
  },
  {
    "id": "3e01fb5d8d",
    "name": "Round Glass Ornament FR",
    "color": [
      "Default"
    ],
    "size": [
      "76x76mm"
    ]
  },
  {
    "id": "543a8bb934",
    "name": "Round Glass Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3''"
    ]
  },
  {
    "id": "5af35bca9c",
    "name": "Semi-Circular Banner",
    "color": [
      "White"
    ],
    "size": [
      "36''x18''",
      "72''x36''"
    ]
  },
  {
    "id": "d48c20e9b9",
    "name": "Stained Glass Suncatcher",
    "color": [
      "Transparent"
    ],
    "size": [
      "3.94''",
      "5.9''",
      "7.87''",
      "9.84''"
    ]
  },
  {
    "id": "0708112af4",
    "name": "Stained Glass Suncatcher - Type 2",
    "color": [
      "Transparent"
    ],
    "size": [
      "3.94''",
      "5.9''",
      "7.87''",
      "9.84''"
    ]
  },
  {
    "id": "a0b9bd51ff",
    "name": "Stainless Steel Tumbler US 2",
    "color": [
      "Default"
    ],
    "size": [
      "20oz Skinny",
      "20oz Curved",
      "30oz"
    ]
  },
  {
    "id": "50572390e1",
    "name": "Standard Doormat 6 mm FR",
    "color": [
      "Default"
    ],
    "size": [
      "60x40cm",
      "75x50cm",
      "90x60cm"
    ]
  },
  {
    "id": "ba88e2dce1",
    "name": "Suncatcher Ornaments 2 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "659d650c8257f",
    "name": "Sweatshirt 2D US",
    "color": [
      "BLACK",
      "FOREST GREEN",
      "SAND",
      "SPORT GREY",
      "LIGHT PINK",
      "MILITARY GREEN",
      "MAROON",
      "RED",
      "ROYAL BLUE",
      "ASH GREY",
      "WHITE",
      "ORANGE",
      "NAVY",
      "DARK HEATHER",
      "ANTIQUE CHERRY RED",
      "CARDINAL RED",
      "CAROLINA BLUE",
      "CHARCOAL",
      "CHERRY RED",
      "DARK CHOCOLATE",
      "GARNET",
      "GOLD",
      "GRAPHITE HEATHER",
      "HEATHER DARK GREEN",
      "HEATHER DARK MAROON",
      "HEATHER DARK NAVY",
      "HEATHER DEEP ROYAL",
      "HEATHER SCARLET RED",
      "HELICONIA",
      "INDIGO BLUE",
      "IRISH GREEN",
      "LIGHT BLUE",
      "PURPLE",
      "SAFETY GREEN",
      "SORANGE",
      "SAFETY PINK",
      "SAPPHIRE"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "659d64e4e2287",
    "name": "T-Shirt 2D US",
    "color": [
      "BLACK",
      "WHITE",
      "LIGHT BLUE",
      "CHARCOAL",
      "NAVY",
      "RED",
      "SPORT GREY",
      "MAROON",
      "DARK HEATHER",
      "ROYAL BLUE",
      "LIGHT PINK",
      "SAND",
      "FOREST GREEN",
      "ASH GREY",
      "PURPLE",
      "MILITARY GREEN",
      "ORANGE",
      "ANTIQUE CHERRY RED",
      "ANTIQUE IRISH GREEN",
      "ANTIQUE JADE DOME",
      "ANTIQUE ORANGE",
      "ANTIQUE SAPPHIRE",
      "AQUATIC",
      "AZALEA",
      "BERRY",
      "BLACKBERRY",
      "BLUE DUSK",
      "BROWN SAVANA",
      "CARDINAL",
      "CAROLINA BLUE",
      "COBALT",
      "CORAL SILK",
      "CORN SILK",
      "DAISY",
      "DARK CHOCOLATE",
      "DUSTY ROSE",
      "ELECTRIC GREEN",
      "GARNET",
      "GOLD",
      "GRAPHITE HEATHER",
      "GRAVEL",
      "HEATHER MILITARY GREEN",
      "HEATHER NAVY",
      "HEATHER RADIANT ORCHID",
      "HEATHER RED",
      "HEATHER SAPPHIRE",
      "HELICONIA",
      "ICE GREY",
      "INDIGO BLUE",
      "IRISH GREEN",
      "KIWI",
      "LILAC",
      "LIME",
      "MIDNIGHT",
      "MINT GREEN",
      "NATURAL",
      "NEON BLUE",
      "NEON GREEN",
      "OFF WHITE",
      "RUSSET",
      "SAFETY GREEN",
      "SAFETY ORANGE",
      "SAFETY PINK",
      "SAPPHIRE",
      "SKY",
      "SUNSET",
      "TANGERINE",
      "TENNESSEE ORANGE",
      "TEXAS ORANGE",
      "TROPICAL BLUE",
      "TURF GREEN",
      "TWEED",
      "VIOLET",
      "YELLOW HAZE"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "5c13ad08c5",
    "name": "Throw Pillow FR",
    "color": [
      "Default"
    ],
    "size": [
      "Case Inner 40x40cm"
    ]
  },
  {
    "id": "4782a03e30",
    "name": "Tote Bag OAD113 US",
    "color": [
      "BLACK",
      "NATURAL"
    ],
    "size": [
      "15x16 in"
    ]
  },
  {
    "id": "9799d9699b",
    "name": "Tough Cases (iPhone)",
    "color": [
      "White"
    ],
    "size": [
      "iPhone 7 / 8 / SE",
      "iPhone 7 Plus / 8 Plus",
      "iPhone X / XS",
      "iPhone XR",
      "iPhone XS Max",
      "iPhone 11",
      "iPhone 11 Pro",
      "iPhone 11 Pro Max",
      "iPhone 12 / 12 Pro",
      "iPhone 12 Pro Max",
      "iPhone 12 Mini / 13 Mini",
      "iPhone 13 / 14",
      "iPhone 13 Pro",
      "iPhone 13 Pro Max",
      "iPhone 14 Pro",
      "iPhone 14 Pro Max",
      "iPhone 14 Plus",
      "iPhone 15",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 15 Plus",
      "iPhone 16",
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16 Plus",
      "iPhone 16 E",
      "iPhone 17",
      "iPhone 17 Air",
      "iPhone 17 Pro",
      "iPhone 17 Pro Max"
    ]
  },
  {
    "id": "50881e5f52",
    "name": "Unisex Hoodie Gildan 18500 FR",
    "color": [
      "Black",
      "Navy",
      "White",
      "Sport Grey",
      "Irish Green",
      "Helonica",
      "Azalea",
      "Orange",
      "Gold",
      "Light Pink",
      "Red",
      "Sand",
      "Ash",
      "Orchid",
      "Light Blue",
      "Garnet",
      "Cherry Red",
      "Graphite Heather",
      "Carolina Blue",
      "Military Green",
      "Maroon",
      "Dark Heather",
      "Purple",
      "Dark Chocolate",
      "Royal",
      "Forest Green"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "6d52b3cb34",
    "name": "Unisex Long Sleeves Gildan 2400 FR",
    "color": [
      "Cardinal Red",
      "Charcoal",
      "Forest Green",
      "Orange",
      "Black",
      "Gold",
      "White",
      "Sport Grey",
      "Light Blue",
      "Light Pink",
      "Navy"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "c4fb1b5b3a",
    "name": "Unisex Long Sleeves Gildan 64400 FR",
    "color": [
      "White",
      "Black",
      "Navy",
      "SportGrey",
      "Light Blue",
      "Light Pink"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "e18ef8c616",
    "name": "Unisex Sweater Gildan 18000 FR",
    "color": [
      "Irish Green",
      "White",
      "Gold",
      "Helonica",
      "Light Pink",
      "Red",
      "Ash",
      "Sand",
      "Light Blue",
      "Garnet",
      "Sport Grey",
      "Graphite Heather",
      "Caroliane Blue",
      "Maroon",
      "Military Green",
      "Purple",
      "Dark Heather",
      "Dark Chocolate",
      "Forest Green",
      "Navy",
      "Black",
      "Royal",
      "Orange"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "ed4abd31be",
    "name": "Unisex T-Shirt Gildan 5000 FR",
    "color": [
      "Black",
      "White",
      "Navy",
      "Red",
      "Sport Grey",
      "Sand",
      "Light Pink",
      "Light Blue"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "de44d74edf",
    "name": "Unisex T-Shirt Gildan 64000 FR",
    "color": [
      "Charcoal",
      "Dark Chocolate",
      "Military Green",
      "Natural",
      "Light Blue",
      "Red",
      "Sport Grey",
      "Navy",
      "Black",
      "White",
      "Light Pink",
      "Orange"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL"
    ]
  },
  {
    "id": "b9e4a90228",
    "name": "Wallet Insert Card Double-sided",
    "color": [
      "Silver"
    ],
    "size": [
      "3.34''x2.08''"
    ]
  },
  {
    "id": "837c16e2ff",
    "name": "Wallet Insert Card Single-sided",
    "color": [
      "Silver"
    ],
    "size": [
      "3.34''x2.08''"
    ]
  },
  {
    "id": "6ccde6f880",
    "name": "Window Hanging Suncatcher Ornaments 1 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''",
      "12''"
    ]
  },
  {
    "id": "fef8f9384a",
    "name": "Women’s Micro Rib Baby Tee Bella+Canvas 1010 US",
    "color": [
      "Solid Cocoa Blend",
      "Solid Forest Blend",
      "Solid Maroon Blend",
      "Solid Vintage Navy Blend",
      "Athletic Heather",
      "Solid Baby Blue Blend",
      "Solid Black Blend",
      "Solid Natural Blend",
      "Solid Navy Blend",
      "Solid Pink Blend",
      "Solid Red Blend",
      "Solid White Blend"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL"
    ]
  },
  {
    "id": "d45bd4adce",
    "name": "Women's T-shirt Gildan G5000L 2D US",
    "color": [
      "AQUATIC",
      "ASHGREY",
      "AZALEA",
      "BLACK",
      "BLUE DUSK",
      "CAROLINA BLUE",
      "CHARCOAL",
      "CORAL SILK",
      "DAISY",
      "DARK HEATHER",
      "DUSTY ROSE",
      "FOREST GREEN",
      "GOLD",
      "GRAPHITE HEATHER",
      "HEATHER NAVY",
      "HEATHER SAPPHIRE",
      "HELICONIA",
      "IRISH GREEN",
      "LIGHT BLUE",
      "LIGHT PINK",
      "MAROON",
      "MINT GREEN",
      "NAVY",
      "OFF WHITE",
      "ORANGE",
      "PURPLE",
      "RED",
      "ROYAL BLUE",
      "SAPPHIRE",
      "SPORT GREY",
      "TROPICAL BLUE",
      "VIOLET",
      "WHITE"
    ],
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL"
    ]
  },
  {
    "id": "124feb51d6",
    "name": "Wood - Acrylic Custom Shape Magnets 2 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "97a5c4e5bc",
    "name": "Wood - Wood Custom Shape Magnets 2 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "acee648c6a",
    "name": "Wood - Wood Custom Shaped Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''",
      "5.5''"
    ]
  },
  {
    "id": "0fcbd52c83",
    "name": "Wood Custom Shaped Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4''",
      "4.5''",
      "5.5''"
    ]
  },
  {
    "id": "d79c19d091",
    "name": "Wood Keychain 2 side US",
    "color": [
      "Default"
    ],
    "size": [
      "2''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "6fad1dbe49",
    "name": "Wood Keychain US",
    "color": [
      "Default"
    ],
    "size": [
      "2''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "142f387c60",
    "name": "Wood- Acrylic Custom Shaped Ornament US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''",
      "5.5''"
    ]
  },
  {
    "id": "1f7501dc0a",
    "name": "Wooden Car Visor Clip 1 Layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''",
      "5.5''"
    ]
  },
  {
    "id": "d541c9730f",
    "name": "Wooden Car Visor Clip 2 Layer US",
    "color": [
      "Default"
    ],
    "size": [
      "4''",
      "5''",
      "6''",
      "7''"
    ]
  },
  {
    "id": "2060642807",
    "name": "Wooden Custom Shape Magnets 1 layer US",
    "color": [
      "Default"
    ],
    "size": [
      "3''",
      "4''",
      "5''"
    ]
  },
  {
    "id": "9cf83d9196",
    "name": "Wooden Custom shape Standing 1 layer (3mm) US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "9092b9bab4",
    "name": "Wooden custom shape Standing 2 layer (3mm) US",
    "color": [
      "Default"
    ],
    "size": [
      "6''",
      "8''",
      "10''",
      "12''"
    ]
  },
  {
    "id": "719281d416",
    "name": "Wooden custom shape Standing 2 layer (5mm) US",
    "color": [
      "Default"
    ],
    "size": [
      "5.5''",
      "6''",
      "8''",
      "10''"
    ]
  },
  {
    "id": "ebd8b2b829",
    "name": "Wooden Door Sign 1 layer - 5mm US",
    "color": [
      "Default"
    ],
    "size": [
      "12''",
      "14''",
      "18''"
    ]
  },
  {
    "id": "14e64bc7f5",
    "name": "Wooden Door Sign 2 layer - 5mm US",
    "color": [
      "Default"
    ],
    "size": [
      "12''",
      "14''",
      "18''"
    ]
  },
  {
    "id": "d1cdc59e78",
    "name": "Wooden Ornament 5mm US",
    "color": [
      "Default"
    ],
    "size": [
      "4.5''",
      "5''",
      "7''",
      "9''"
    ]
  },
  {
    "id": "24cc7609bf",
    "name": "Wooden Ornament Car US",
    "color": [
      "Default"
    ],
    "size": [
      "3.5''",
      "4.5''"
    ]
  },
  {
    "id": "4b558baad2",
    "name": "Wooden Personalized Photo Bookmark US",
    "color": [
      "Gray",
      "Pink",
      "Dark Green",
      "Sky Blue",
      "Deep Green"
    ],
    "size": [
      "2''x8''",
      "3''",
      "4''"
    ]
  },
  {
    "id": "3dd47871f2",
    "name": "Youth Hoodie Gildan G18500B 2D US",
    "color": [
      "AZALEA",
      "BLACK",
      "CARDINAL RED",
      "CAROLINA BLUE",
      "CHARCOAL",
      "DARK HEATHER",
      "FOREST GREEN",
      "GOLD",
      "GRAPHITE HEATHER",
      "HELICONIA",
      "IRISH GREEN",
      "LIGHT PINK",
      "MAROON",
      "NAVY",
      "ORANGE",
      "PURPLE",
      "RED",
      "ROYAL",
      "SPORT GREY",
      "VIOLET",
      "WHITE"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "07e5636d3c",
    "name": "Youth Sweatshirt Gildan G18000B 2D US",
    "color": [
      "BLACK",
      "DARK HEATHER",
      "FOREST GREEN",
      "MAROON",
      "NAVY",
      "RED",
      "ROYAL BLUE",
      "SAFETY PINK",
      "SPORT GREY",
      "WHITE"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": "02ad36b0c1",
    "name": "Youth T-Shirt G5000B 2D US",
    "color": [
      "Black",
      "White",
      "Irish Green",
      "Light Pink",
      "Forest Green",
      "AQUATIC",
      "ASHGREY",
      "AZALEA",
      "BLUE DUSK",
      "CARDINAL RED",
      "CAROLINA BLUE",
      "CHARCOAL",
      "COBALT",
      "CORAL SILK",
      "DAISY",
      "DARK CHOCOLATE",
      "DARK HEATHER",
      "DUSTY ROSE",
      "ELECTRIC GREEN",
      "GARNET",
      "GOLD",
      "GRAPHITE HEATHER",
      "HEATHER NAVY",
      "HEATHER RED",
      "HEATHER SAPPHIRE",
      "HELICONIA",
      "INDIGO BLUE",
      "KIWI",
      "LIGHT BLUE",
      "LIME",
      "MAROON",
      "MILITARY GREEN",
      "MINT GREEN",
      "NATURAL",
      "NAVY",
      "NEONBLUE",
      "NEONGREEN",
      "OFF WHITE",
      "ORANGE",
      "PURPLE",
      "RED",
      "ROYAL",
      "SAFETY GREEN",
      "SORANGE",
      "SAFETY PINK",
      "SAND",
      "SAPPHIRE",
      "SKY",
      "SPORTGREY",
      "TENNESSEE ORANGE",
      "TORANGE",
      "TROPICAL BLUE",
      "VIOLET",
      "YELLOWHAZE"
    ],
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  }
];

export default merchfoxManual;
